import getAdminSettings from "./getAdminSettings";
import updateSetting from "./updateSetting";
import checkStatusInUse from "./checkStatusInUse";

const mockResponses = { getAdminSettings, updateSetting, checkStatusInUse };

export default mockResponses;
